import React from 'react';
// @ts-ignore
import styles from './SubscriptionPaymentMethodSelectItem.module.scss';

interface Props {
	icon: string;
	title: string;
	type: string;
	onClick: (type: string) => void;
}

const SubscriptionPaymentMethodSelectItem: React.FC<Props> = ({
	icon,
	title,
	type,
	onClick,
}) => {
	return (
		<div className={styles.wrapper} onClick={() => onClick(type)}>
			<img src={icon} alt='icon' className={styles.icon} />
			<div className={styles.content}>
				<div className={styles.title}>{title}</div>
			</div>
			<div className={styles.arrow}>
				<img src='/dist/patientV3/icons/arrow-right-purple-small.svg' alt='' />
			</div>
		</div>
	);
};

export default SubscriptionPaymentMethodSelectItem;
